<template lang="pug">
component(
  :is="sectionComponent"
  :class="{ '--first': index === 0 }"
  :section="section"
)
</template>

<script>
import DefaultSection from '@/components/post/section/default-section'
import ImageSection from '@/components/post/section/image-section'
import OembedSection from '@/components/post/section/oembed-section'

export default {
  name: 'post-content__section',
  props: {
    section: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
    },
  },
  computed: {
    sectionType() {
      return this.section.kind || 'text'
    },
    sectionComponent() {
      switch (this.sectionType) {
        case 'oembed':
        case 'embed':
          return OembedSection
        case 'img':
        case 'image':
          return ImageSection
        case 'html':
        case 'text':
        default:
          return DefaultSection
      }
    },
  },
  methods: {
    renderSection(s) {
      if (typeof s === 'string') return s.replace(/\n/g, '<br/>')
      switch (s.kind) {
        case 'img':
          return `<div class="img-wrapper" style="padding-bottom: calc(${
            s.height
          }/${s.width}*100%)"><img src="${s.src}" /></div>`
        default:
          return s.content.replace(/\n/g, '<br/>')
      }
    },
  },
}
</script>

<style lang="sass">
/* see App.vue for these root styles:
  --post-content-font-size: 1.25rem
  --post-content-line-height: 1.5 */

.post-content__section
  margin-bottom: 1rem

  &.--img
    border: 1px solid var(--base-color)
    margin-top: 2rem
    margin-bottom: 2rem

  &.--first.--text
    font-size: 1.6rem

</style>
